import { Check } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';

interface SaveButtonProps extends Omit<IconButtonProps, 'children'> {
    onSave: () => void;
}

const SaveButton: React.FC<SaveButtonProps> = ({ onSave, sx, ...props }) => {
    return (
        <IconButton
            size="small"
            onClick={onSave}
            {...props}
            sx={{
                color: 'success.light',
                '&:hover': {
                    bgcolor: 'success.main',
                    color: 'success.contrastText',
                },
                ...sx
            }}
        >
            <Check fontSize="inherit" />
        </IconButton>
    );
};

export default SaveButton; 